module.exports = __webpack_public_path__ + "static/media/im6.5b203edc.png";